// extracted by mini-css-extract-plugin
export default {"icon":"qQNeMCgZKTDLeaD","hidden":"S0JrttnF97V2Dnq"};